import React from "react";
import CommonDropdown from "../../../components/dropdown/CommonDropdown";
import DropdownButton from "../../../components/dropdown/DropdownButton";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import { AppContext } from "../../../contexts/AppContext";
import { FaPlus } from "react-icons/fa6";
import PropTypes from "prop-types";

function LogosDataTable({ linhas, togLogoModal, apagaLogo }) {
  const { baseUrl } = React.useContext(AppContext);

  const colunas = React.useMemo(
    () => [
      {
        Header: "Nome",
        accessor: "nome",
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <div className="row text-end">
              <CommonDropdown>
                <DropdownButton
                  key={`visualizar-${row.original.caminho}`}
                  onClick={() => {
                    window.open(`${baseUrl}${row.original.caminho}`, "_blank");
                  }}
                  color="primary"
                  icon="mdi mdi-eye"
                >
                  Visualizar
                </DropdownButton>
                <DropdownButton
                  key={`excluir-${row.original.caminho}`}
                  onClick={() => {
                    apagaLogo(row.original.arquivo);
                  }}
                  color="danger"
                  icon="mdi mdi-delete"
                >
                  Excluir
                </DropdownButton>
              </CommonDropdown>
            </div>
          );
        },
      },
    ],
    [apagaLogo, baseUrl]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <ButtonRounded onClick={togLogoModal} color="success" icon={<FaPlus />}>
          Nova logo
        </ButtonRounded>
      }
    />
  );
}

LogosDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  togLogoModal: PropTypes.func.isRequired,
  apagaLogo: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default LogosDataTable;
